import { useState, useEffect } from 'react';
import Link from '@/components/Link';
import Container from '@/components/Container';
import Image from '@/components/Image/RemoteImage';
import Form from '@/components/Forms';

export default function CertificationValidationTool() {
  const [license, setLicense] = useState(null);

  useEffect(() => {
    if (license !== null) {
      window.open(`//certificaciones.aibes.org/${license}`);
      setLicense(null);
    }
  }, [license]);

  return (
    <div className="relative z-10 bg-gradient-to-b from-green-100 to-white py-10 lg:py-20 xl:pt-28 xl:pb-32">
      <Container className="relative z-10 space-y-10 lg:space-y-12">
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="space-y-4 lg:col-span-7 lg:space-y-6">
            <h1 className="text-4xl font-extrabold tracking-tight lg:text-5xl xl:text-6xl">
              Validación de certificaciones
            </h1>
            <p className="font-med text-lg leading-relaxed text-gray-600 lg:pr-28">
              La herramienta de validación de certificaciones puede ser
              utilizada por empleadores, clientes y otras partes interesadas
              para validar la autenticidad de las&nbsp;
              <Link
                className="font-medium text-gray-900"
                href="/certificaciones"
              >
                certificaciones
              </Link>
              &nbsp;avaladas por la Asociación Iberoamericana de Scrum AIBES.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12">
          <div className="rounded-full bg-white shadow-outside lg:col-span-9">
            <Form
              initialValues={{
                license: '',
              }}
              onSubmit={(values, { resetForm }) => {
                setLicense(values.license);
                resetForm();
              }}
            >
              {({ values, handleChange, handleBlur }) => (
                <div className="flex w-full">
                  <div className="hidden items-center space-x-2 border-r border-gray-200 py-5 pl-8 pr-6 md:flex">
                    <svg
                      className="h-5 w-5 text-gray-300"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <div className="text-lg font-medium lg:text-xl lg:font-semibold">
                      Número de licencia
                    </div>
                  </div>
                  <div className="flex flex-1">
                    <input
                      type="text"
                      className="w-full rounded-l-full border-2 border-transparent px-5 text-lg placeholder-gray-300 focus:border-green-500 focus:outline-none focus:ring-4 focus:ring-green-500 focus:ring-opacity-20 md:rounded-none lg:text-2xl"
                      placeholder="Ej. 21170830"
                      name="license"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.license}
                      required
                    />
                  </div>
                  <div className="relative z-0 px-3 py-3">
                    <button
                      className="w-full rounded-full bg-green-500 px-5 py-3 text-lg font-medium leading-6 text-white hover:bg-green-600 focus:bg-green-600 focus:outline-none focus:ring-4 focus:ring-green-600 focus:ring-opacity-20 lg:px-8 lg:text-lg lg:font-semibold"
                      type="submit"
                    >
                      <svg
                        className="h-5 w-5 md:hidden"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <div className="hidden md:block">Verificar</div>
                    </button>
                  </div>
                </div>
              )}
            </Form>
          </div>
        </div>
      </Container>
      <div className="absolute inset-0 z-0 hidden md:flex">
        <Container className="relative flex h-full py-10">
          <div className="grid w-full grid-cols-12">
            <div className="relative col-span-5 col-start-8 flex">
              <Image
                className="rounded-lg object-cover shadow-lg lg:rounded-xl"
                src="v1612316006/validar/herramienta-de-validacion_ukkpnu.jpg"
                alt="Validación de certificados"
                layout="fill"
              />
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}
